<template>
  <div class="wildPlantInfo">
  <div class="wildPlantInfo-lg">
    <el-descriptions class="margin-top" :title="this.title + '详情'" style="text-align: center"  :column="3"  border>
      <el-descriptions-item label="科中文名" prop="sectionChinese">
        {{ infoContent.sectionChinese }}
      </el-descriptions-item>
      <el-descriptions-item label="科拉丁名" prop="sectionLatin">
        {{ infoContent.sectionLatin }}
      </el-descriptions-item>
      <el-descriptions-item label="中文名" prop="chineseName">
        {{ infoContent.chineseName }}
      </el-descriptions-item>
      <el-descriptions-item label="学名" prop="scientificName">
        {{ infoContent.scientificName }}
      </el-descriptions-item>
      <el-descriptions-item label="国家重点保护" prop="countryProtect">
        {{ infoContent.countryProtect }}
      </el-descriptions-item>
      <el-descriptions-item label="中国红色名录" prop="redDirectory">
        {{ infoContent.redDirectory }}
      </el-descriptions-item>
      <el-descriptions-item label="云南极小种群" prop="minimumPopulation" span="3">
        {{ infoContent.minimumPopulation }}
      </el-descriptions-item>
      <el-descriptions-item label="本项目区域中的分布" prop="distribution" span="3">
        {{ infoContent.distribution }}
      </el-descriptions-item>
      <el-descriptions-item label="备注" prop="note">
        {{ infoContent.note }}
      </el-descriptions-item>
      <el-descriptions-item label="发布时间" prop="createTime">
        {{ infoContent.createTime }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div class="wildPlantInfo-sm">
    <el-descriptions class="margin-top" :title="this.title + '详情'" style="text-align: center"  :column="3"  border>
      <el-descriptions-item label="科中文名" prop="sectionChinese">
        {{ infoContent.sectionChinese }}
      </el-descriptions-item>
      <el-descriptions-item label="科拉丁名" prop="sectionLatin">
        {{ infoContent.sectionLatin }}
      </el-descriptions-item>
      <el-descriptions-item label="中文名" prop="chineseName">
        {{ infoContent.chineseName }}
      </el-descriptions-item>
      <el-descriptions-item label="学名" prop="scientificName">
        {{ infoContent.scientificName }}
      </el-descriptions-item>
      <el-descriptions-item label="国家重点保护" prop="countryProtect">
        {{ infoContent.countryProtect }}
      </el-descriptions-item>
      <el-descriptions-item label="中国红色名录" prop="redDirectory">
        {{ infoContent.redDirectory }}
      </el-descriptions-item>
      <el-descriptions-item label="云南极小种群" prop="minimumPopulation" span="3">
        {{ infoContent.minimumPopulation }}
      </el-descriptions-item>
      <el-descriptions-item label="本项目区域中的分布" prop="distribution" span="3">
        {{ infoContent.distribution }}
      </el-descriptions-item>
      <el-descriptions-item label="备注" prop="note">
        {{ infoContent.note }}
      </el-descriptions-item>
      <el-descriptions-item label="发布时间" prop="createTime">
        {{ infoContent.createTime }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
  </div>
</template>

<script>
export default {
  name: "wildPlantInfo",
  props: {
    infoContent: Object,
    title: String
  },

}
</script>

<style scoped lang="scss">
.wildPlantInfo {
.wildPlantInfo-lg {
  display: block;
}
.wildPlantInfo-sm {
  display: none;
}
}
::v-deep .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  text-align: center !important;
}
@media screen and (max-width: 1200px) {
  .wildPlantInfo {
    .wildPlantInfo-lg {
      display: none;
    }
    .wildPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .wildPlantInfo {
    .wildPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .wildPlantInfo {
    .wildPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .wildPlantInfo {
    .wildPlantInfo-lg {
      display: none;
    }
    .wildPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
